<template>
  <div>
    <Filtro @filtro="makeFiltro"></Filtro>
    <vx-card>
      <ListUsers
        :filtro="filtro"
        :realizaFiltro="realizaFiltro"
        @filtroOk="finalizaFiltro"
        :subjectPermission="subjectPermission"
      ></ListUsers>
    </vx-card>
  </div>
</template>

<script>
import ListUsers from "./ListUsuarios";
import Filtro from "./FiltroUsuario";
export default {
  data() {
    return {
      realizaFiltro: false,
      filtro: null,
      subjectPermission: "Usuário",
    };
  },
  methods: {
    makeFiltro(filtro) {
      console.log(filtro);
      this.realizaFiltro = true;
      this.filtro = filtro;
    },
    finalizaFiltro() {
      this.realizaFiltro = false;
    },
  },
  components: {
    ListUsers,
    Filtro,
  },
};
</script>
